import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/board-change.svg";
var BoardChangeOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BoardChangeOutline_default as default
};
